export enum ServiceCost {
  /** 免费 */
  free = 1,
  /** 收费 */
  fee = 2,
  /** 待开发 */
  noOpen = 3,
  /** 私有化附赠 */
  bonus = 4,
  //联系客服
  customer = 5
}

export const ServiceCostSort = [
  ServiceCost.customer,
  ServiceCost.fee,
  ServiceCost.bonus,
  ServiceCost.free,
  ServiceCost.noOpen,
]
